import { sum } from 'lib/array/arrayUtils'
import { createSelector } from 'reselect'
import getTotalsWithoutInsurance from '../payment/getTotalsWithoutInsurance'
import { applyClassicRewardDeduction } from '../payment/applyClassicRewardDeduction'
import { getClassicRewards } from '../view/generic'
import { getFlightItems } from '../view/flights'

const getInsuranceCoverAmountFromCart = createSelector(
  (state: App.State) => getTotalsWithoutInsurance(state),
  (state: App.State) => getClassicRewards(state),
  (state: App.State) => getFlightItems(state),
  (totals, classicRewards, flightItems): number | undefined => {
    if (totals.hasRequiredData) {
      const {
        paidPrice = 0,
        price = 0,
        surcharge = 0,
        otherFees = {},
      } = totals.data
      const rawTotal = paidPrice + price + surcharge + sum(Object.values(otherFees))
      return applyClassicRewardDeduction({ amount: rawTotal, classicRewards, flightItems }).amount
    }
  },
)

export default getInsuranceCoverAmountFromCart
